<template>
    <div class="sensorPage fullPage">
        <v-left ref="treeLeft" @changeWay="changeWayFn" />
        <div style="width:calc(100% - 300px)">
            <div class="device-status-desc">{{ $t(deviceStatusButton[sensorWay].title) }}</div>
            <components :selectDeviceType="selectDeviceType" :is="sensorWay" ref="componentContent" :deviceType="deviceType" style="height:calc(100% - 50px)"></components>
        </div>

        <!-- <v-button :optareBtn="statusOPtareBtn" class="rightDropdown" @changeWayFn="changeWayFn"></v-button> -->
        <i class="iconfont icon-excel question excel" :title="$t('integration.export_template')" v-show="sensorWay === 'unknown'" @click="loadFileFn"></i>
    </div>
</template>

<script>
import bus from '@/utils/bus.js'
import { getGeneraUploadTemplateFile } from '@/api/modules/deviceUrl.js'

import leftTree from '../gateway/components/leftTree.vue'
import bindPage from './components/sensor/bind/bindPage.vue'
import unBindPage from './components/sensor/unbind/unbindPage.vue'
import stopPage from './components/sensor/stop/stopPage.vue'
import unknowPage from './components/sensor/unknow/unknowPage.vue'
import { deviceStatusButton, deviceTypeListConvert } from '@/utils/convert'
import pleaseSelect from '@/common/pleaseSelect'
import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'
export default {
  name: 'sensor',
  computed: {
    deviceStatusButton: () => deviceStatusButton
  },
  components: {
    'v-left': leftTree,
    // 'v-right': RightContent,
    bind: bindPage,
    unbind: unBindPage,
    stop: stopPage,
    unknown: unknowPage
  },
  data () {
    return {
      sensorWay: ENUM_DEVICE_WAY.BIND,
      deviceType: [],
      selectDeviceType: []
    }
  },
  created () {
    this.getInitDeviceData()
  },
  methods: {
    // 获取传感器类型 -- 说明以后这种类型但凡后台添加一个  前端这里直接添加多一个静态数据就可以了  不需要再去传递值给其他组件 这里的值 只需要给未确认的新增哪里就行了
    getInitDeviceData () {
      this.$store.dispatch('device/getSensorType').then(res => {
        // 在这里重新把label字段国际化一下吧，本来应该在utils/matchDeviceType文件国际化更好，但是报错，不知道怎么做
        res.forEach(item => {
          item.label = deviceTypeListConvert[item.code]
        })
        this.deviceType = res
        this.selectDeviceType = [pleaseSelect, ...res]
      })
    },
    loadFileFn () {
      getGeneraUploadTemplateFile('sensor', this.$i18n.locale).then(res => {})
    },
    changeWayFn (item) {
      this.$refs.treeLeft.filterText = null
      const { way } = item
      this.sensorWay = way

      // 重置左侧树形搜索条件
      if (way === ENUM_DEVICE_WAY.UNBIND || way === ENUM_DEVICE_WAY.UNCONFIRM) {
        this.$refs.componentContent.SearchForm.scopeName = this.$store.getters.SchemaTree[0].label
      } else {
        this.$refs.componentContent.SearchForm.scopeName = null
      }
      this.$refs.componentContent.SearchForm.sceneId = null

      //  this.$refs.componentContent.getListFn();
      /** 抛出一个方法修改树形结构数据 醉了 */

      bus.$emit('editTree', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './style/public.scss';

.sensorPage {
    .rightDropdown {
        /**  这里使用下定位 因为之前疯转这个search时候将他们form 与 optare按钮作为了一个整体 不能使用flex*/
        position: absolute;
        right: 35px;
        top: 10px;
    }

    .question {
        position: absolute;
        right: 35px;
        top: 75px;
        font-size: 18px;
        cursor: pointer;
        color: #9bccfd;

        &:hover {
            color: var(--primary-color);
        }
    }

    .excel {
        right: 55px;
    }
}
</style>
